/**
 * Settle time before a typed value is acted on — every search box across desktop and admin, plus the
 * org-management search hooks. One value so the same keystroke costs the same wait wherever a user
 * types, and so tuning responsiveness is a single edit rather than a sweep.
 *
 * Applies to searches that do I/O. A filter over a list already in memory should run on the keystroke:
 * settling a synchronous match only adds lag.
 */
export const DEBOUNCE_MS = 300;
